export function formatDate(locale: string, date: Date) {
	return date.toLocaleDateString(locale, { day: "numeric", month: "long", year: "numeric" });
}

export const capitalize = (str: string) => str.charAt(0).toUpperCase() + str.slice(1);

export function formatYoutubeLink(link: string) {
	const videoId = link.split("v=")[1];
	return `https://www.youtube.com/embed/${videoId}`;
}

export function formatUrl(url: string) {
	const youtubeRegex = new RegExp("^(https?://)?(www.)?(youtube.com|youtu.?be)/.+$");
	if (youtubeRegex.test(url)) {
		formatYoutubeLink(url);
	}
	return url;
}
